import { styled } from '@linaria/react';

export const CommentItem = styled.div`
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;
    margin-bottom: 1rem;
`;

export const CommentMeta = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;
    color: #6c757d;
    font-size: 0.875rem;
`;

export const CommentText = styled.p`
    color: #495057;
    line-height: 1.5;
    margin: 0;
`;
